import {authFetch} from "../../authentication/authFetch";

const API_URL = process.env.REACT_APP_API_URL;

async function parseResponse(response) {
    const contentType = response.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
        return response.json();
    }
    return null;
}

export const startSession = async (sessionData, authToken) => {
    const safeSessionData = sessionData ?? {};
    const normalizedProjectId = safeSessionData.projectId ?? safeSessionData.project_id ?? null;
    // Basic validation
    if (!authToken) {
        throw new Error('Missing auth token – cannot start session');
    }

    // Provide all potentially required fields; adjust to backend contract
    const bodyRequest = {
        taskId: safeSessionData.taskId ?? null,
        projectId: normalizedProjectId,
        project_id: normalizedProjectId,
        planned_duration_seconds: safeSessionData.planned_duration_seconds ?? 1500, // default pomodoro length
        focusMode: safeSessionData.focusMode ?? 'STANDARD',
        sessionType: safeSessionData.sessionType ?? 'POMODORO',
    };

    const response = await authFetch(`${API_URL}/api/session/start`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(bodyRequest)
    });

    if (!response.ok) {
        throw new Error('Failed to start session');
    }

    const data = await parseResponse(response);
    return data?.id ?? data?.sessionId ?? null;
}

export const completeSession = async (sessionId, authToken) => {
    if (!authToken || !sessionId) {
        return null;
    }

    const response = await authFetch(`${API_URL}/api/session/${sessionId}/complete`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    });

    if (!response.ok) {
        throw new Error('Failed to complete session');
    }

    return parseResponse(response);
}
